<template>
    <div>
        <!-- <p-button @click="onSaveUserGroupPrivileges()" outline class="hover-text min float-right"><i class="fa fa-check"></i><span>{{ $t('button.save') }}</span></p-button>                         

        <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" /> -->

        <b-table 
            :sort-by.sync="sortBy"
            :items="userGroupPrivileges" 
            :fields="fields" 
            :filter="filter"
            @filtered="onFiltered"
            :per-page="perPage"
            :current-page="currentPage">

            <!-- <template v-slot:cell(selected)="{ item, index }">
                <input type="checkbox" :id="item.id" v-model="item.selected">
            </template> -->
            <template v-slot:cell(selected)="{ item }">
                <p class="mb-0">
                    <b-icon icon="check-circle" variant="success" v-if='item.selected' @click="toggleSelected(item)" 
                    font-scale="1.2" 
                    class="clickable"></b-icon>
                    <b-icon icon="x-circle" variant="secondary" v-if='!item.selected' @click="toggleSelected(item)" 
                    font-scale="1.2"
                    class="clickable"></b-icon>
                </p>
            </template>
            
        </b-table>

        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'

export default {
    components: { TablePagination },
        props: ['filter', 'item'],
        data() {
            return {
                perPage: 10,
                currentPage: 1,
                filteredRows: 0,
                fields: [
                    { key: "id", label: this.$t('users.id'), sortable:"true" },
                    { key: "description", label: this.$t('users.description'), sortable:"true" },
                    { key: "selected", label: "" }
                ],
                sortBy:"id",               
                userGroupPrivileges: [],
                ok: false,
                error: false,
                savingPrivileges: false,
                loading: false,
                infoType: "save"
            }
    },
    computed: {
        totalRows() {
            return this.filter ? this.filteredRows : (this.userGroupPrivileges ? this.userGroupPrivileges.length : 0);
        },               
        selectedUserGroupPrivileges() {
            var selectedItems = [];
            
            for (var ug of this.userGroupPrivileges) {
                if( ug.selected ) {
                    selectedItems.push(ug);
                }
            }
            return selectedItems;               
        }                             
    },
    created() {
        this.getUserGroupPrivileges(this.item.id);
    },
    watch: {
        item: function(item) {
            this.getUserGroupPrivileges(item.id);
            this.ok = this.error = this.loading = false;  
        }
    }, 
    methods: {
        listContains(item, list) {
            for(var i = 0; i < list.length; i++) {
                if(list[i].id === item.id) {
                    return true;
                }
            }
            return false;
        },    
        getUserGroupPrivileges(item) {
            this.$store.dispatch('userDataHandler/getUserGroup' , item ).then( response => {
                this.userGroupPrivileges = response.data.privileges;
            });                
        },
       toggleSelected(item) {
            item.selected = !item.selected;
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            this.savingPrivileges = true;

            setTimeout(() => { 
                this.$store.dispatch('userDataHandler/saveUserGroupPrivileges' , this.selectedUserGroupPrivileges, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                })
            }, 1000);
       },
        onSaveUserGroupPrivileges(event) {
            if( event ) 
                event.preventDefault();   
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;
            
            setTimeout(() => { 
                this.$store.dispatch('userDataHandler/saveUserGroupPrivileges' , this.selectedUserGroupPrivileges, this.item.id).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.$emit('updateItem', this.item);
                })
            }, 1000);
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            if (!this.savingPrivileges) {
                this.currentPage = 1;
            } else {
                this.savingPrivileges = false;
            }
        },
        onPageChange(page){
            this.currentPage = page
        }
    }
}
</script>
